import React from 'react';

const TabContent = (props) => {
    const { className, style, value, children } = props;

    const tab = React.Children.toArray(children).find(tab => tab.props.value === value);

    return (
        <div className={`content${className ? ` ${className}` : ''}`} style={style}>
            { tab ? React.cloneElement(tab) : null }
        </div>
    )
}

export default TabContent;
